<template>
  <div class="modal-mask" v-show="showFieldEditModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <b-tabs
          content-class="mt-3"
          fill
          style="margin: 20px 0; overflow-x: hidden; max-height: 500px"
        >
          <b-tab title="Свойства" active>
            <div class="d-flex justify-content-between">
              <div>Класс:</div>
              <div>{{ selectedProduct.code }} {{ selectedProduct.title }}</div>
            </div>
            <div class="form-group">
              <label>Наименование свойства</label>
              <input
                type="text"
                class="form-control"
                :value="fieldEdit.title"
                disabled
              />
            </div>
            <div class="form-group">
              <label>Описание свойства</label>
              <input
                type="text"
                class="form-control"
                v-model="fieldEdit.comment"
              />
            </div>
            <div class="form-group">
              <label>Обязательное свойство?</label>
              <select
                class="form-control"
                v-model="fieldEdit.isRequired"
                :disabled="
                  fieldEdit.inputType === 'multiselect' || fieldEdit.index === 0
                "
              >
                <option value="1" :selected="fieldEdit.isRequired">Да</option>
                <option value="0" :selected="!fieldEdit.isRequired">Нет</option>
              </select>
            </div>
            <div class="form-group">
              <label>Дата удаления (Не обязательно)</label>
              <date-picker
                class="w-100"
                v-model="fieldEdit.delete_at"
                valueType="format"
              ></date-picker>
            </div>
            <div class="form-group">
              <label
                >Тип свойства (RADIO | CHECKBOX | TEXT | NUMBER |
                MULTISELECT)</label
              >
              <select
                class="form-control"
                v-model="fieldEdit.inputType"
                disabled
              >
                <option value="0" disabled>Выберите тип</option>
                <option
                  v-for="fieldType in fieldTypes"
                  :value="fieldType.value"
                  :key="fieldType.id"
                >
                  {{ fieldType.title }}
                </option>
              </select>
            </div>
            <!-- ******** RANGEBLOCK ******** -->
            <div id="RangeBlockEdit" v-if="fieldEdit.inputType === 'range'">
              <div class="w-100 d-flex justify-content-sm-between">
                <h4>Диапазон</h4>
                <a class="btn btn-success cursor" @click="addRowRange()">+</a>
              </div>

              <div v-for="(row, index) in fieldValues" :key="index" :row="row">
                <div class="row">
                  <div
                    class="col-md-12 d-flex"
                    :class="{ 'bg-danger': row.state && row.state !== 'A' }"
                  >
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>От</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="row.value.from"
                          spellcheck="true"
                          :disabled="typeof row.field_id !== 'undefined'"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>До</label>
                        <div class="d-flex">
                          <input
                            type="text"
                            class="form-control"
                            v-model="row.value.to"
                            spellcheck="true"
                            :disabled="typeof row.field_id !== 'undefined'"
                          />
                          <a
                            class="btn btn-danger ml-2 cursor"
                            :class="{
                              'bg-warning': row.state && row.state !== 'A',
                            }"
                            @click="deleteRow(index)"
                            >{{
                              row.state && row.state !== "A" ? "activate" : "X"
                            }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ******** RANGEBLOCK ******** -->

            <!-- ******** CHECKBOXBLOCK ******** -->
            <div
              id="CheckBoxBlockEdit"
              v-if="
                fieldEdit.inputType === 'checkbox' ||
                fieldEdit.inputType === 'radio' ||
                fieldEdit.inputType === 'multiselect'
              "
            >
              <div class="w-100 d-flex justify-content-sm-between">
                <h2 v-if="fieldEdit.inputType === 'checkbox'">
                  Несколько из нескольких
                </h2>
                <h2 v-if="fieldEdit.inputType === 'radio'">
                  Один из нескольких
                </h2>
                <h2 v-if="fieldEdit.inputType === 'multiselect'">
                  MULTISELECT
                </h2>
                <a class="btn btn-success cursor" @click="addRowCheckBox()"
                  >+</a
                >
              </div>

              <div v-for="(row, index) in fieldValues" :key="index" :row="row">
                <div class="row">
                  <div
                    class="col-md-12 d-flex"
                    :class="{ 'bg-danger': row.state && row.state !== 'A' }"
                  >
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Значение</label>
                        <div class="d-flex">
                          <select
                            v-if="fieldEdit.inputType === 'multiselect'|| fieldEdit.index === 0"
                            class="form-control"
                            :class="{ 'bg-warning': row.dublicate }"
                            v-model="row.value"
                            :disabled="typeof row.field_id !== 'undefined'"
                            @change="checkSameValues(fieldValues)"
                          >
                            <option
                              v-for="(unit, index) in units"
                              :key="index"
                              :value="unit.title"
                              :selected="unit.title === row.value"
                            >
                              {{ unit.title }}
                            </option>
                          </select>
                          <input
                            v-else
                            type="text"
                            class="form-control"
                            v-model="row.value"
                            spellcheck="true"
                            @change="checkSameValues(fieldValues)"
                            :disabled="typeof row.field_id !== 'undefined'"
                          />
                          <a
                            class="btn btn-danger ml-2 cursor"
                            :class="{
                              'bg-warning': row.state && row.state !== 'A',
                            }"
                            @click="deleteRow(index)"
                            >{{
                              row.state && row.state !== "A" ? "activate" : "X"
                            }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ******** CHECKBOXBLOCK ******** -->
          </b-tab>
          <b-tab
            title="Добавить перевод"
            v-if="fieldEdit || fieldEdit.translations"
          >
            <div class="form-group">
              <label>Язык</label>
              <select
                class="form-control"
                @change="onSelectFieldLang()"
                v-model="fieldEdit.language"
              >
                <option disabled>Выберите тип</option>
                <option
                  v-if="!inArray(language.lang, fieldEdit.translations, 2)"
                  v-for="language in languages"
                  :value="language.lang"
                  :key="language.id"
                >
                  {{ language.lang }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="fieldEdit.language != null">
              <div class="form-group">
                <label>Наименование [{{ fieldEdit.language }}]</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="fieldEdit[fieldEdit.language + '_title']"
                />
              </div>
              <div class="form-group">
                <label>Описание свойства [{{ fieldEdit.language }}]</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="fieldEdit[fieldEdit.language + '_comment']"
                />
              </div>
              <div
                id="CheckBoxBlockEditLang"
                v-if="
                  fieldEdit.inputType === 'checkbox' ||
                  fieldEdit.inputType === 'radio'
                "
              >
                <div class="w-100 d-flex justify-content-sm-between">
                  <h2 v-if="fieldEdit.inputType === 'checkbox'">CHECKBOX</h2>
                  <h2 v-if="fieldEdit.inputType === 'radio'">Radio</h2>
                </div>

                <div
                  v-for="(row, index) in checkboxRowsForLanguage"
                  :key="index"
                  :row="row"
                >
                  <div class="row">
                    <div class="col-md-12 d-flex">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Значение {{ fieldEdit.language }}</label>
                          <div class="d-flex">
                            <input
                              type="text"
                              class="form-control"
                              v-model="row.value"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Существует">
            <div
              v-for="translation in fieldEdit.translations"
              :key="translation.id"
            >
              <p>[{{ translation.locale }}] - {{ translation.title }}</p>
            </div>
          </b-tab>
        </b-tabs>

        <div class="modal-footer">
          <slot name="footer">
            <button
              class="modal-button btn btn-danger"
              @click="updateTab('update', false)"
            >
              Закрыть
            </button>
            <button class="modal-button btn btn-success" @click="fieldUpdate()">
              Изменить
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { POST } from "@/shared/api";
import { funcs } from "@/_helpers/_sumple_funcs";

export default {
  props: {
    fieldValues: [],
    selectedProduct: {
      code: null,
      title: null,
    },
    showFieldEditModal: false,
    fieldEdit: {},
    units: [],
    languages: [],
  },
  data() {
    return {
      checkboxRows: [{ value: "" }],
      checkboxRowsForLanguage: [],
      rangeRows: [{ from: "", to: "" }],
      fieldTypes: [
        {
          id: 1,
          value: "range",
          title: "Диапазон",
        },
        {
          id: 2,
          value: "checkbox",
          title: "Несколько из нескольких (checkbox)",
        },
        {
          id: 3,
          value: "boolean",
          title: "Да Нет (Boolean)",
        },
        {
          id: 4,
          value: "radio",
          title: "Один из нескольких (radio)",
        },
        {
          id: 5,
          value: "text",
          title: "Текстовое поле (text)",
        },
        {
          id: 6,
          value: "number",
          title: "Числовое поле (number)",
        },
        {
          id: 7,
          value: "multiselect",
          title: "один из многих",
        },
      ],
    };
  },
  methods: {
    updateTab(event = "update", spec) {
      this.$emit(event, spec);
      // console.log(this.specification.fields);
    },
    fieldUpdate() {
      this.fieldEdit.values = this.fieldValues;
      if (this.fieldEdit.language != null) {
        this.fieldEdit[this.fieldEdit.language + "_values"] =
          this.checkValuesForLanguage();
      }
      POST(this.fieldEdit, "/fieldUpdate", this)
        .then((response) => {
          this.valuesEditSetDefault();
          this.updateTab("update", { state: "updated", response: response });
        })
        .catch(() => {
          this.valuesEditSetDefault();
          // this.closeFieldEditModal();
        });
    },
    checkValuesForLanguage() {
      if (
        funcs.inArray(this.fieldEdit.inputType, [
          "checkbox",
          "checkbox",
          "radio",
        ])
      ) {
        let prepareArray = [];
        for (let key in this.checkboxRowsForLanguage) {
          prepareArray.push(this.checkboxRowsForLanguage[key]["value"]);
        }
        return JSON.stringify(prepareArray);
      }
    },
    addRowRange() {
      this.fieldValues.push({ value: { from: "", to: "" } });
    },
    deleteRow(index) {
      if (typeof this.fieldValues[index].state !== "undefined") {
        if (this.fieldValues[index].state === "A") {
          this.fieldValues[index].state = "P";
        } else {
          this.fieldValues[index].state = "A";
        }
      } else {
        this.fieldValues.splice(index, 1);
      }
    },
    addRowCheckBox() {
      this.fieldValues.push({ value: "" });
    },
    deleteRowCheckBox(index) {
      this.fieldValues.splice(index, 1);
    },
    valuesEditSetDefault() {
      this.checkboxRows = [{ value: "" }];
      this.rangeRows = [{ from: "", to: "" }];
      this.fieldEdit.values = null;
      this.fieldEdit.isRequired = 0;
      this.fieldEdit.inputType = 0;
      this.prepareFieldValues = [];
    },

    onSelectFieldLang() {
      for (let index = 0; index < this.fieldEdit.translations.length; index++) {
        if (
          this.fieldEdit.translations[index].locale === this.fieldEdit.language
        ) {
          this.fieldEdit[this.fieldEdit.language + "_title"] =
            this.fieldEdit.translations[index].title;
          this.fieldEdit[this.fieldEdit.language + "_comment"] =
            this.fieldEdit.translations[index].comment;

          if (
            this.fieldEdit.inputType === "checkbox" ||
            this.fieldEdit.inputType === "radio"
          ) {
            this.checkboxRowsForLanguage = [];
            for (
              var i = 0;
              i < this.fieldEdit.translations[index].values.length;
              i++
            ) {
              var prepareCheckBoxValue = {
                value: this.fieldEdit.translations[index].values[i],
              };
              this.checkboxRowsForLanguage.push(prepareCheckBoxValue);
            }
          }
        } else {
          this.checkboxRowsForLanguage = [];
          for (let index = 0; index < this.fieldEdit.values.length; index++) {
            this.checkboxRowsForLanguage.push({ value: "" });
          }
        }
      }
    },
    inArray(lang, translations, mode) {
      if (!Array.isArray(translations)) {
        return false;
      }
      let res = [];
      let locales = [];
      if (mode === 2) {
        translations.forEach((el) => {
          locales.push(el.locale);
        });
        res = locales;
      } else {
        res = translations;
      }
      return funcs.inArray(lang, res);
    },
    checkSameValues(fieldValues) {
      let found = false;
      fieldValues.map((value) => {
        found = false;
        if (value.state === "A") {
          fieldValues.map((value2) => {
            if (value2.id !== value.id && value2.value === value.value) {
              value.dublicate = true;
              found = true;
            }
          });
          if (!found) {
            value.dublicate = false;
          }
        }
        return value;
      });
    },
  },
  watch: {
    fieldValues: function (newVal) {
      this.checkSameValues(newVal);
      console.log("newVal", newVal);
    },
    "fieldValues.value": function (newVal) {
      this.checkSameValues(newVal);
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
